import React from "react";
import CudyLogo from "../../../assets/cudyLogo.png";
import styles from "./Logo.module.css";

export default function Logo() {
	const handleLogoClick = () => {
		window.location.href = "/";
	};

	return (
		<img
			className={styles.logo}
			srcSet={CudyLogo}
			alt="Cudy Logo"
			onClick={handleLogoClick}
		/>
	);
}
